// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Idqs","title":"Info_title__2_fcx","links":"Info_links__JUHAn","link":"Info_link__2lVs7","logo":"Info_logo__18Fgk"};